<permission-checker [roles]="roles" (contentInit)="initContent()" (rolesLoaded)="callerRolesUpdated($event)">
  <div class="content-holder">
    <contest-select-panel [competitionId]="competitionId"
                          [contest]="contest"
                          [mobileView]="mobileView"
                          [showDetails]="false"
                          (selected)="contestSelected($event)"></contest-select-panel>

    <mat-accordion *ngIf="user" class="filters-panel">
      <mat-expansion-panel [expanded]="!region || !schoolGrade || (!school && region.id != '-1')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <ng-container *ngIf="region">{{region.name}}</ng-container>
            <ng-container *ngIf="!region"
                          i18n="User Profile|School region select input label@@user-profile-school-region-select-input-label"
            >Select Region</ng-container>
          </mat-panel-title>
          <mat-panel-description>
            <ng-container *ngIf="schoolGrade">{{schoolGrade}}&thinsp;</ng-container>
            <ng-container *ngIf="taskType">({{localizeTaskType(taskType)}})</ng-container>
            <ng-container *ngIf="(schoolGrade || taskType) && school">&thinsp;|&nbsp;</ng-container>
            <ng-container *ngIf="school">{{school.short_name || school.name}}</ng-container>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <school-select
          [roles]="roles"
          [showGrade]="true"
          [showGradeType]="true"
          [allowGradeSelect]="true"
          [selectedGrade]="schoolGrade"
          [selectedRegion]="region"
          [allowRegionSelect]="true"
          [addAllRegionsOption]="true"
          [allowSchoolSelect]="true"
          [showSchool]="true"
          [selectedSchoolType]="schoolType"
          [selectedSchool]="school"
          [clearSchoolAfterSelect]="false"
          [allowSchoolClear]="true"
          [schoolRequired]="false"
          (gradeSelected)="gradeSelected($event.grade, $event.type)"
          (regionSelected)="regionSelected($event)"
          (schoolSelected)="schoolSelected($event.school, $event.region)"></school-select>

        <div *ngIf="showStatsExport && examStats && examStats.length > 0" class="export-holder">
          <div class="fill-space"></div>
          <app-link icon="verified"
                    label="export stats"
                    [disabled]="inProgress || exportInProgress"
                    i18n-label="Stats Dashboard|Export stats title@@stats-dashboard-export-stats-title"
                    (click)="exportStats()"></app-link>
          <mat-spinner *ngIf="exportInProgress" diameter="20" color="primary" class="export-progress"></mat-spinner>
          <a *ngIf="!exportInProgress && exportUrl" [href]="exportUrl" target="_blank">
            <mat-icon color="primary">get_app</mat-icon>
          </a>
        </div>

      </mat-expansion-panel>
    </mat-accordion>

    <app-no-content *ngIf="!inProgress && !contest"
                    [compact]="true"
                    title="Please select a contest and grade from the list first"
                    i18n-title="Stats Dashboard|Select contest and grade prompt@@stats-dashboard-select-contest-and-grade-prompt"
                    details="Stats will be loaded for the selected region and contest"
                    i18n-details="Stats Dashboard|Select contest prompt detail@@stats-dashboard-select-contest-prompt-detail">
    </app-no-content>

    <exam-results-table *ngIf="examStats && examStats.length > 0;else noStatsInfo"
                        class="full-width"
                        [mobileView]="mobileView"
                        [examStats]="examStats"
                        [regions]="regions"
                        [showAnswerSheets]="true"
                        [showTimeSpent]="showTimeSpent"
                        [contest]="contest"
                        [caller]="user"
                        [callerRegion]="callerRegion"
                        [callerSchool]="callerSchool"
                        [callerSession]="session"></exam-results-table>

    <ng-template #noStatsInfo>
      <app-no-content *ngIf="!inProgress && contest"
                      [compact]="true"
                      title="No statistical data available at the moment"
                      i18n-title="Stats|User exam card stats missing title@@stats-user-exam-card-stats-missing-title"
                      details="Stats will be populated after students participate in the contest"
                      i18n-details="Stats|Users exam stats missing details@@stats-users-exam-stats-missing-details"></app-no-content>
    </ng-template>

    <mat-spinner *ngIf="inProgress" color="primary" diameter="30" class="center progress"></mat-spinner>

    <div *ngIf="page && page.next_token" class="center-align load-more-holder">
      <app-link class="load-more-link"
                icon="arrow_downward"
                label="load more"
                i18n-label="Students List|Load More link label@@students-list-load-more-link-label"
                (click)="loadNextPage()"></app-link>
    </div>
  </div>
</permission-checker>
